import React from "react";

import "./loader.css";

const Loader = () => {
  return (
    <div className="loading-wrapper">
      <div className="loading-circle" />
    </div>
  );
};

export default Loader;
